import React from 'react';
import { object, func, bool, string } from 'prop-types';
import _ from 'lodash';
import PasswordInput from '../PasswordInput';
import { Errors } from '../../../constants/errors';
import { useTranslation } from 'react-i18next';

const PasswordComp = ({ formData, handleFormState, isFromChangePwd }) => {
  const {
    password,
    passwordErr,
    confirmPassword,
    confirmPasswordErr,
    currentPassword,
    currentPasswordErr,
    oneNumber,
    eightChar,
    lowerCaseLetter,
    capitalLetter,
    specialLetter,
    spaceCheck,
    apiCommonValidationError
  } = formData;
  const { t } = useTranslation();
  const onInputChange = event => {
    const { name, value } = event.target;
    if (name === 'password') {
      handleFormState({
        ...formData,
        [name]: value,
        eightChar: value.length >= 8,
        lowerCaseLetter: /[a-z]/.test(value),
        oneNumber: /[0-9]/.test(value),
        capitalLetter: /[A-Z]/.test(value),
        specialLetter: /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(value),
        spaceCheck: /\s/.test(value),
        passwordMatch: !_.isEmpty(value) && _.isEqual(confirmPassword, value),
        [`${name}Err`]: '',
        confirmPasswordErr: '',
        apiCommonValidationError: false
      });
    } else {
      handleFormState({
        ...formData,
        [name]: value,
        passwordMatch: !_.isEmpty(value) && _.isEqual(password, value),
        [`${name}Err`]: ''
      });
    }
  };

  const onInputBlur = event => {
    const { name, value } = event.target;
    let passwordErr = '';
    if (_.isEmpty(value.trim())) {
      passwordErr = 'Required';
    } else if (
      name === 'password' &&
      (!(
        eightChar &&
        lowerCaseLetter &&
        oneNumber &&
        capitalLetter &&
        specialLetter
      ) ||
        spaceCheck)
    ) {
      passwordErr = 'InvalidPassword';
    } else if (
      !_.isEmpty(confirmPassword) &&
      !_.isEqual(confirmPassword, password)
    ) {
      handleFormState({
        ...formData,
        confirmPasswordErr: Errors['PasswordMatch']
      });
      return;
    }
    handleFormState({
      ...formData,
      [`${name}Err`]: Errors[passwordErr],
      apiCommonValidationError: false
    });
  };

  return (
    <div>
      {isFromChangePwd && (
        <PasswordInput
          password={currentPassword}
          name="currentPassword"
          label={t('Current password')}
          onInputBlur={onInputBlur}
          error={t(currentPasswordErr)}
          onInputChange={onInputChange}
        />
      )}
      <PasswordInput
        parentClass="width75"
        password={password}
        name="password"
        error={t(passwordErr)}
        label={t('Password')}
        onInputChange={onInputChange}
        onInputBlur={onInputBlur}
        showInfoIcon={true}
        autoFocus={true}
        autoComplete="new-password"
        passwordPlaceholder="Password"
        isFromSignupFlow={true}
        apiCommonValidationError={apiCommonValidationError}
      />
      <PasswordInput
        parentClass="width75"
        password={confirmPassword}
        error={t(confirmPasswordErr)}
        label={t('Re-type password')}
        name="confirmPassword"
        onInputChange={onInputChange}
        onInputBlur={onInputBlur}
        autoComplete="new-password"
        passwordPlaceholder="Confirm Password"
        isFromSignupFlow={true}
        confirmPasswordErr={formData && formData.confirmPasswordErr}
      />
    </div>
  );
};

PasswordComp.propTypes = {
  formData: object,
  parentClass: string,
  handleFormState: func,
  isFromChangePwd: bool,
  apiCommonValidationError: bool
};

PasswordComp.defaultProps = {
  isFromChangePwd: false,
  apiCommonValidationError: false
};
export default PasswordComp;
